<template>
  <v-container>
    <v-row>
      <v-col cols="3">
        <v-text-field label="网站名称" v-model="website.name"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="URL" v-model="website.url"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="创建时间" v-model="website.createTime"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-form ref="slideForm">
          <v-card>
            <v-card-title>首页幻灯片</v-card-title>
            <v-container>
              <v-row v-for="(slideModule, i) of slideModules" :key="`slide${i}`">
                <v-col cols="3">
                  <v-text-field label="图片链接" v-model="slideModule.imageUrl" :rules="rules.required"/>
                </v-col>
                <v-col cols="3">
                  <v-text-field label="主标题" v-model="slideModule.title"/>
                </v-col>
                <v-col cols="2">
                  <v-text-field label="副标题" v-model="slideModule.subtitle"/>
                </v-col>
                <v-col cols="2">
                  <v-text-field label="跳转链接" v-model="slideModule.targetUrl"/>
                </v-col>
                <v-col cols="2">
                  <v-text-field label="按钮文字" v-model="slideModule.btnText"
                                append-icon="mdi-plus" append-outer-icon="mdi-minus"
                                @click:append="add(slideModules)" @click:append-outer="remove(i, slideModules)"/>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary" class="mr-3" @click="saveSlideModules">保存</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>热销商品</v-card-title>
          <v-container>
            <v-row v-for="(topSaleModule, i) of topSaleModules" :key="`slide${i}`">
              <v-col cols="3">
                <v-text-field label="图片链接" v-model="topSaleModule.imageUrl"/>
              </v-col>
              <v-col cols="3">
                <v-text-field label="主标题" v-model="topSaleModule.title"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="副标题" v-model="topSaleModule.subtitle"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="跳转链接" v-model="topSaleModule.targetUrl"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="按钮文字" v-model="topSaleModule.btnText"
                              append-icon="mdi-plus" append-outer-icon="mdi-minus"
                              @click:append="add(topSaleModules)" @click:append-outer="remove(i, topSaleModules)"/>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" class="mr-3" @click="saveSlideModules">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>新到商品</v-card-title>
          <v-container>
            <v-row v-for="(newArrivalModule, i) of newArrivalModules" :key="`slide${i}`">
              <v-col cols="3">
                <v-text-field label="图片链接" v-model="newArrivalModule.imageUrl"/>
              </v-col>
              <v-col cols="3">
                <v-text-field label="主标题" v-model="newArrivalModule.title"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="副标题" v-model="newArrivalModule.subtitle"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="跳转链接" v-model="newArrivalModule.targetUrl"/>
              </v-col>
              <v-col cols="2">
                <v-text-field label="按钮文字" v-model="newArrivalModule.btnText"
                              append-icon="mdi-plus" append-outer-icon="mdi-minus"
                              @click:append="add(newArrivalModules)"
                              @click:append-outer="remove(i, newArrivalModules)"/>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" class="mr-3" @click="saveSlideModules">保存</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "WebsiteManager",
  data() {
    return {
      website: {
        name: null,
        url: null,
        createTime: null,
        updateTime: null
      },
      slideModules: [
        {
          imageUrl: null,
          title: null,
          subtitle: null,
          targetUrl: null,
          btnText: null
        }
      ],
      topSaleModules: [
        {
          imageUrl: null,
          title: null,
          subtitle: null,
          targetUrl: null,
          btnText: null
        }
      ],
      newArrivalModules: [
        {
          imageUrl: null,
          title: null,
          subtitle: null,
          targetUrl: null,
          btnText: null
        }
      ],
      rules: {
        required: [
          v => !!v || '必填项'
        ]
      }
    }
  },
  methods: {
    add(array) {
      array.push({});
    },
    remove(index, array) {
      array.splice(index, 1)
    }
  }
}
</script>

<style scoped>

</style>